import { RootReducer } from '../rootReducer';

export const isAuthenticatedSelector = (state: RootReducer) => state.auth.isAuthenticated;
export const isAuthenticationCompleteSelector = (state: RootReducer) => state.auth.isComplete;
